import { Box, Text, Flex, useColorModeValue, Link } from '@chakra-ui/react';
import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';

export const Footer = () => {
	return (
		<Box bg={useColorModeValue('gray.50', 'gray.900')} color={useColorModeValue('gray.700', 'gray.200')}>
			<Box py={10}>
				<Flex
					align={'center'}
					_before={{
						content: '""',
						borderBottom: '1px solid',
						borderColor: useColorModeValue('gray.200', 'gray.700'),
						flexGrow: 1,
						mr: 8
					}}
					_after={{
						content: '""',
						borderBottom: '1px solid',
						borderColor: useColorModeValue('gray.200', 'gray.700'),
						flexGrow: 1,
						ml: 8
					}}
				>
					<Text mr="10px">Repo </Text>
					<Link href="https://github.com/Ankomahene/ms-react-progress-bar">
						<FaGithub />
					</Link>
				</Flex>
				<Text pt={6} fontSize={'sm'} textAlign={'center'}>
					© MS React Progress Bar. All rights reserved
				</Text>
				<Flex pt="10px" w="100%" fontSize={'sm'} alignItems={'center'} justifyContent="center">
					<Text>Built with ❤️ By Mister Shadrack </Text>
					<Flex border="1px" borderColor={useColorModeValue('gray.200', 'gray.700')} ml="10px" p="5px">
						<Link href="https://github.com/ankomahene" mx="5px">
							<FaGithub />
						</Link>
						<Link href="https://www.linkedin.com/in/shadrack-ankomahene-5a393311a/" mx="5px">
							<FaLinkedin />
						</Link>
						<Link href="https://twitter.com/Mister_Shadrack" mx="5px">
							<FaTwitter />
						</Link>
					</Flex>
				</Flex>
			</Box>
		</Box>
	);
};
